import { VEC2 } from '@/utils/math/vector'
import { computed, defineComponent } from 'vue'
import type { ISpeechBubbleProps } from './types'

const shadowFilter = `drop-shadow(4px 8px 6px rgba(0,0,0, 0.4))`
const tipBorderRadius = '0.1rem'

const SpeechBubble = defineComponent<ISpeechBubbleProps>({
  name: 'SpeechBubble',
  setup(props, { slots }) {
    const placement = computed(() => props.placement || 'middle')

    const position = computed(() => {
      switch (placement.value) {
        case 'left':
          return VEC2(0, 0)
        case 'right':
          return VEC2(0, 0)
        case 'top':
          return { x: 0, y: '-8px' }
        case 'top-right':
          return { x: '96%', y: '-32px' }
        case 'top-left':
          return { x: '-25%', y: '-32px' }
        case 'bottom':
          return VEC2(0, 0)
        default:
        case 'middle':
          return VEC2(0, 0)
      }
    })

    return () => {
      const body = (
        <div
          style={{
            backgroundColor: 'white',
            color: 'black',
            fontSize: '0.75rem',
            borderRadius: tipBorderRadius,
            padding: '0.5rem',
            width: '100%',
            height: '100%',
            position: 'relative',
            pointerEvents: 'none'
            //boxShadow: shadow,
          }}
        >
          {slots.default ? slots.default() : ''}
        </div>
      )

      const tip = (
        <div
          style={{
            width: '1rem',
            display: 'inline-block',
            borderStyle: 'solid',
            borderWidth: '10px 10px 0',
            borderColor: 'white transparent',
            borderRadius: `${tipBorderRadius}`,
            position: 'absolute',
            bottom: '-7px',
            // boxShadow: shadow,

            ...(placement.value === 'top-left'
              ? {
                  right: `${tipBorderRadius}`
                }
              : {
                  left: `${tipBorderRadius}`,
                  right: `${tipBorderRadius}`
                }),
            // marginLeft: 'auto',
            // marginRight: 'auto',
            pointerEvents: 'none'
          }}
        />
      )

      return (
        <div
          style={{
            width: 'fit-content',
            height: 'fit-content',
            minWidth: '10rem',
            minHeight: '2rem',
            filter: shadowFilter,
            //paddingLeft: '1rem',
            //paddingRight: '1rem',
            position: 'absolute',
            pointerEvents: 'none',
            zIndex: 110,
            top: `${position.value.y}`,
            left: `${position.value.x}`
          }}
        >
          {body}
          {tip}
        </div>
      )
    }
  }
})
SpeechBubble.props = ['placement']
export default SpeechBubble
